export const CheckIcon = ({ size = 16, color = '#4688ec', ...props }) => (
  <svg
    fill="none"
    height={size}
    width={size}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      clipRule="evenodd"
      d="M1 3c0-1.10457.89543-2 2-2h10c1.1046 0 2 .89543 2 2v10c0 1.1046-.8954 2-2 2H3c-1.10457 0-2-.8954-2-2zm2-.5c-.27614 0-.5.22386-.5.5v10c0 .2761.22386.5.5.5h10c.2761 0 .5-.2239.5-.5v-10c0-.27614-.2239-.5-.5-.5zm9.3262 2.98014-5.00003 5.99996c-.1425.171-.35359.2699-.57617.2699s-.43367-.0989-.57617-.2699l-2.5-2.99996 1.15234-.96028 1.92383 2.3086 4.4238-5.3086z"
      fill={color}
      fillRule="evenodd"
    />
  </svg>
);

export const LockIcon = ({ size = 16, color = '#f15b50', ...props }) => (
  <svg
    fill="none"
    height={size}
    width={size}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M8 2.5c-.82843 0-1.5.67157-1.5 1.5h3c0-.82843-.67157-1.5-1.5-1.5zm3 1.52074v-.02074c0-1.65685-1.34315-3-3-3s-3 1.34315-3 3v.02074c-.29048.04873-.55266.18096-.761.37115l-.88669-.63334-.91695-2.06315-1.37072.6092.94464 2.12544c.09062.20389.23416.37981.41572.50949l1.325.94643v1.11404h-3.25v1.5h3.25v1.14872l-1.14979.95818c-.13248.1104-.24068.247-.3178.4012l-1.20323 2.4065 1.34164.6708 1.17984-2.3597.46058-.3838c.63558 1.5764 2.17703 2.6581 3.94022 2.6581h.24854c1.71908 0 3.1849-1.0844 3.7506-2.6066l.3987.3323 1.1799 2.3597 1.3416-.6708-1.2032-2.4065c-.0771-.1542-.1853-.2908-.3178-.4012l-1.1498-.95818v-1.14872h3.25v-1.5h-3.25v-1.11404l1.325-.94643c.1816-.12968.3251-.3056.4157-.50949l.9447-2.12544-1.3708-.6092-.9169 2.06315-.8867.63334c-.2083-.19019-.4705-.32242-.761-.37115zm-.25 5.97926v-4.5h-5.5v4.44265l.03488.22675c.20629 1.3408 1.35998 2.3306 2.71658 2.3306h.24854c1.38071 0 2.5-1.1193 2.5-2.5z"
      fill={color}
    />
  </svg>
);

export const ClipboardIcon = ({ size = 20, color = '#6A9A23', ...props }) => (
  <svg
    fill="none"
    height={size}
    width={size}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5 5.5V4.75H16V5.5V7H14.5H13.75V8.5H14.5H16V10V10.75H17.5V10V8.5H19H19.75V7H19H17.5V5.5ZM12 5H6C4.89543 5 4 5.89543 4 7V16C4 17.1046 4.89543 18 6 18H18C19.1046 18 20 17.1046 20 16V12H18.5V16C18.5 16.2761 18.2761 16.5 18 16.5H6C5.72386 16.5 5.5 16.2761 5.5 16L5.5 8L11.25 8H12V6.5L11.25 6.5L6 6.5H12V5Z"
      fill={color}
    />
  </svg>
);

export const FlashIcon = ({ size = 16, color = '#bf63f3', ...props }) => (
  <svg
    fill="none"
    height={size}
    width={size}
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      clipRule="evenodd"
      fillRule="evenodd"
      d="M10.271.050656c.2887.111871.479.38969.479.699344v4.63515l3.1471.62941c.2652.05303.4812.24469.5655.50161s.0238.53933-.1584.73914l-7.74997 8.49999c-.20863.2288-.53644.3059-.82517.194-.28874-.1118-.47905-.3896-.47905-.6993v-4.6351l-3.14708-.62947c-.26515-.05303-.48123-.24468-.56553-.5016-.08431-.25692-.02379-.53933.1584-.73915l7.75-8.499996c.20863-.2288201.53643-.305899.8252-.194028zm-6.57276 8.724134 3.05177.61036v3.92915l5.55179-6.08909-3.05179-.61036v-3.9291z"
      fill={color}
    />
  </svg>
);

export const TaskIcon = ({ size = 18, color = '#6A9A23', ...props }) => (
  <svg width={size} height={size} viewBox="0 0 16 16" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 3c0-0.55228 0.44772-1 1-1h10c0.5523 0 1 0.44772 1 1v10c0 0.5523-0.4477 1-1 1H3c-0.55228 0-1-0.4477-1-1zm3.5 2c-.2761 0-.5.2239-.5.5v5c0 .2761.2239.5.5.5h5c.2761 0 .5-.2239.5-.5v-5c0-.2761-.2239-.5-.5-.5zm.5 1v4h4v-4z"
      fill={color}
    />
  </svg>
);
